import { get } from "lodash";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { NavLink } from "react-router-dom";
import { Dropdown, Button, Icon } from "semantic-ui-react";

import { ADD_RESOURCE_OPERATIONS_BY_TYPE } from "../../constants/operations.js";
import { ROUTES } from "../../constants/routing.js";
import {
  AT_TYPES_TO_RESOURCE_KEYS,
  RESOURCE_AT_TYPES
} from "../../constants/entity.js";

import { getIconByType } from "./resourceIcon/ResourceIconMap.js";

import { operationAvailability } from "../../utils/operations.js";
import { selectLimits } from "../../state/reducers/account/limitSelector.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class AddResourceDropdownMenu extends PureComponent {
  static propTypes = {
    project: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    createAvailability: PropTypes.object.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    disabled: false
  };

  // -- RENDER -- //

  renderAddResourceDropDownItem = (type, availability) => {
    const { project, limits, copy } = this.props;
    const { permitted, enabled } = availability;

    // no limits object returned means the user has no creation permissions so we can abort early
    if (permitted !== true || !limits) return null;

    const disabled = (limits[type] && limits[type].available < 1) || !enabled;

    const lowerCaseType = AT_TYPES_TO_RESOURCE_KEYS[type].toLowerCase();

    return (
      <Dropdown.Item
        as={NavLink}
        to={`${ROUTES.PROJECT_WIZARD}/add-${lowerCaseType}/resources/${project.id}`}
        key={`${type}Option`}
        disabled={disabled}
      >
        <Icon name={getIconByType(type)} />
        {copy(`project.add_new_${lowerCaseType}_cta`)}
      </Dropdown.Item>
    );
  };

  render() {
    const { createAvailability, disabled } = this.props;

    const notPermitted = Object.keys(createAvailability).every(availabilty => {
      availabilty.permitted === false;
    });

    if (disabled || notPermitted) return null;

    return (
      <Dropdown
        trigger={<Button icon="plus circle" floated="right" />}
        icon={null}
        direction="left"
        pointing="right"
        className="float-right"
        disabled={disabled}
      >
        <Dropdown.Menu className="project-dropdown-menu">
          {RESOURCE_AT_TYPES.map(resourceAtType => {
            return this.renderAddResourceDropDownItem(
              resourceAtType,
              createAvailability[resourceAtType]
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

const mapStateToProps = (state, props) => {
  const operations = get(props, "project.operations", {});

  const createAvailability = RESOURCE_AT_TYPES.reduce((acc, resourceAtType) => {
    acc[resourceAtType] = operationAvailability(
      ADD_RESOURCE_OPERATIONS_BY_TYPE[resourceAtType],
      operations
    );
    return acc;
  }, {});

  return {
    createAvailability,
    limits: selectLimits(state, props),
    copy: selectCopy(state)
  };
};

export default connect(mapStateToProps)(AddResourceDropdownMenu);
